import { render, staticRenderFns } from "./categoryArchive.vue?vue&type=template&id=cddeac92&"
import script from "./categoryArchive.vue?vue&type=script&lang=js&"
export * from "./categoryArchive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports